import React from 'react';
import { css } from '@emotion/react';
import { useClientUser } from '@/hooks';
import ArchiveDocuments from '@/components/Account/ArchiveDocuments';
import CustomDocuments from '@/components/Account/CustomDocuments';
import { AccentBar, Card, Section, SectionHeader, SectionTitle } from '../blocks';

// Documents are stored per client, so the existing Account panels operating under the
// overridden context read and write the shipper's own document set.
const KeyDocs = () => {
    const { client_id } = useClientUser();

    return (
        <>
            <Section>
                <SectionHeader>
                    <AccentBar />
                    <SectionTitle>Documents</SectionTitle>
                </SectionHeader>
                <Card>
                    <div
                        css={css`
                            padding: 1.25rem;
                        `}
                    >
                        {/* `bare` — this Card is the surface; the panels must not add their own. */}
                        <CustomDocuments bare />
                        <ArchiveDocuments client_id={client_id} isAdmin={false} editable={true} bare />
                    </div>
                </Card>
            </Section>
        </>
    );
};

export default KeyDocs;
